import template from './media-filter.html';
import MediaFilterController from './media-filter.controller';
import './media-filter.styl';

let mediaFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: MediaFilterController,
  controllerAs: 'vm'
};

export default mediaFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/media-filter/media-filter.component.js
 **/